import portadaLoginY from 'NewVersion/img/portada-login.jpg'

function LoginHeroImage() {
  return (
    <div className="login-image" aria-hidden="true">
      <img className="login-image__img" src={portadaLoginY} alt="" decoding="async" />
    </div>
  )
}

export default LoginHeroImage
